import GeoDataFormater from "./geo_data_formatter";
import ServiceFactory from "../service_factory";

export const MAX_RETRIES_FOR_WAITING_PLAYER_MESSAGES_CONNECT = 50;

export interface IGeoRequestParams {
    mobileNumber:string;
    licenseKey:string;
    locationTransactionId:string;
    isGeoLocationInProcess:boolean;
    isRetryFlow?: boolean;
}

export interface IGeoLocationParams {
    PC:any;
    Hybrid:any;
    Oobee:any;
    antiFlickerTimer:number;
    geoProcessTimeout:number;
    enable:boolean;
}

export interface IGeoBase {
    setParent(parent):void;
    isPlugInEnable(bMandatory):Promise<boolean>;
    getGeoLocation(data:GeoDataFormater):Promise<void>;
    runWrapper():void;
    cancelGCConnect():void;
}

export default interface IGeoService {
    startLoginGeoProcess(bMandatory, reason?: string):Promise<void>;
    updateGeoPeriodic(geo):Promise<void>;
    onGeoLocationResOk(geoLocationEncryptedResponse):void;
    onGeoLocationResFailed(errorCode:number, errorMessage:string):void
    getServiceFactory():ServiceFactory;
    startRetryGeoProcess():Promise<void>;
    getButtonsForNonRetryGeoFlow(analyticsLabel:string): any[];
}

